// Updated to work with the Node.js backend
const API_BASE = '/api'; // Relative path since same server

export const fetchBotStats = async () => {
  try {
    const response = await fetch('/api/bot-stats');
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    return {
      serverCount: data.server_count || 103,
      totalCommands: data.total_commands || 40470,
      monthlyVotes: data.monthly_votes || 0,
      totalVotes: data.total_votes || 0,
      source: data.source || 'unknown'
    };
  } catch (error) {
    console.error('Error fetching bot stats:', error);
    // Return fallback data
    return {
      serverCount: 103,
      totalCommands: 40470,
      monthlyVotes: 0,
      totalVotes: 0,
      source: 'fallback'
    };
  }
};

export const fetchServerCount = async () => {
  try {
    const stats = await fetchBotStats();
    return stats.serverCount;
  } catch (error) {
    console.error('Error fetching server count:', error);
    return 103; // Fallback
  }
};